import React from 'react'
import Moment from 'moment'
import { FirestoreCollection } from 'react-firestore'
import { toast } from 'react-toastify'

import IntervalRadios from './IntervalRadios'
import LastTouchRadios from './LastTouchRadios'
import FirebaseAuth from '../misc/FirebaseAuth'
import PageLoading from '../misc/PageLoading'
import AppHeader from '../misc/AppHeader'
import Error from '../misc/Error'
import logIn from '../../actions/logIn'
import createPerson from '../../actions/createPerson'
import {
  Page,
} from '../../styles/layout'
import {
  Label,
  TextInput,
} from '../../styles/forms'
import {
  Button,
} from '../../styles/buttons'

const onSubmit = (event, history) => {
  event.preventDefault()
  const {name, intervalValue, intervalUnit, lastTouch, phone} = event.target.elements
  const values = {
    name: name.value,
    interval: {
      value: intervalValue.value,
      unit: intervalUnit.value,
    },
    phone: phone.value,
    lastTouch: Moment().subtract(lastTouch.value, 'days').toDate(),
  }
  createPerson(values)
    .then( () => {
      toast(`Added ${values.name}`)
    })
    .then( () => history.push(`/`))
}

const PersonNew = ({history}) => (
  <Page>
    <AppHeader showBackButton />

    <h1>Add a new person</h1>
    <FirebaseAuth>
      { ({isLoading, error, auth}) => {

        if (error) {
          return <Error error={error} />
        }

        if (isLoading) {
          return <PageLoading />
        }

        if (!auth) {
          return <div>
            <p>You must be logged in to add someone</p>
            <Button onClick={logIn}>log in</Button>
          </div>
        }

        return <FirestoreCollection
          path={'people'}
          filter={['createdBy', '==', auth.uid]}
        >
          { ({isLoading, error, data}) => {

            if (error) {
              return <Error error={error} />
            }

            if (isLoading) {
              return <PageLoading />
            }

            if (data.length >= 100000) {
              return <div>
                <p>You've hit your person limit!</p>
                <Button onClick={() => history.push('/account')}>subscribe</Button>
              </div>
            }

            return <form onSubmit={event => onSubmit(event, history)}>
              <Label>Who do you want to keep in touch with?</Label>
              <TextInput
                autoFocus
                type="text"
                autoComplete="off"
                name="name"
                placeholder="Name"
                required
                large
              />

              <Label>How often do you want to check in?</Label>
              <IntervalRadios />

              <Label>When was the last time you talked to them?</Label>
              <LastTouchRadios />

              <Label>What's their phone number?</Label>
              <TextInput
                type="phone"
                autoComplete="off"
                name="phone"
                placeholder="(123) 456-7890"
              />

              <br />
              <br />

              <Button type="submit">Add this person</Button>
            </form>
          }}
        </FirestoreCollection>
      }}
    </FirebaseAuth>
  </Page>
)

export default PersonNew



// WEBPACK FOOTER //
// ./src/views/personNew/index.js